import type { ApiPriceType } from "../../../../common-deprecated/types/ApiModel";

export const hasDiscount = (price: ApiPriceType): boolean => price.list !== price.listWithDiscount;
